import { AbstractProduct, ConcreteProduct, DeserializedAbstractProduct } from '@/src/lib/product/types';
import { DeserializedCartItem } from '@/src/lib/cart/glue/types/deserialized';
import { DeserializedObject } from '@/src/lib/http/jsonapi/deserializer';
import { DeserializedConcreteProduct } from '@/src/lib/catalog-search/types';

export type TrackingItem = {
  item_id: string;
  item_name: string;
  item_category?: string;
  item_category2?: string;
  price?: number;
  quantity?: number;
};

export type FormattedTrackingProperties = {
  [key: string]: unknown;
  currency: string;
  value: number;
  items: Array<TrackingItem>;
};

export type TrackingEventItem =
  | AbstractProduct
  | DeserializedCartItem
  | DeserializedConcreteProduct
  | DeserializedObject<DeserializedAbstractProduct | ConcreteProduct>;

export type TrackingEventProperties = {
  currency: string;
  value: number;
  items: Array<TrackingEventItem>;
  payment_type?: string;
  payment_method?: string;
  tax?: number;
  shipping?: number;
  shipping_tier?: string;
  transaction_id?: string;
};

export enum TrackingEventName {
  ADD_PAYMENT_INFO = 'add_payment_info',
  ADD_DELIVERY_METHOD = 'add_delivery_method',
  ADD_TO_CART = 'add_to_cart',
  ADD_SHIPPING_INFO = 'add_shipping_info',
  CHECKOUT_BREADCRUMB_ADDRESS = 'checkout_breadcrumb_address',
  CHECKOUT_BREADCRUMB_PAYMENT = 'checkout_breadcrumb_payment',
  CHECKOUT_BREADCRUMB_SHIPPING = 'checkout_breadcrumb_shipping',
  PURCHASE = 'purchase',
  REMOVE_FROM_CART = 'remove_from_cart',
  VIEW_ITEM = 'view_item',
  BEGIN_CHECKOUT = 'begin_checkout',
}
